import { ref, update } from "firebase/database";
import { db } from "../firebaseConfig";

// Updates the available quantity of an item in the Realtime Database
export const updateItemAvailableQuantity = async (
	itemKey: string,
	newAvailableQuantity: number
) => {
	try {
		const itemRef = ref(db, `items/${itemKey}`);
		await update(itemRef, { availableQuantity: newAvailableQuantity });
	} catch (error) {
		console.error("Error updating available quantity:", error);
		throw error;
	}
};
